module.exports = __webpack_public_path__ + "img/ssc-icon.60c991b6.png";